<template>
  <div class="relative" ref="dropdownContainer">
    <button
      class="flex items-center justify-between w-full px-2 py-1 border md:py-1 md:text-base"
      :class="{
        'border-[#ccc] text-gray-500 font-light': !isSelectionComplete,
        [`rounded-${radius} h-${height}`]: true,
        'bg-[#F7F6FB] font-light rounded-lg border-primary text-primary':
          isSelectionComplete,
      }"
      type="button"
      @click="toggleDropdown"
    >
      {{ selectionText }}
      <DropdownIconSvg
        color="black"
        height="4"
        width="4"
        :class="{ 'rotate-180': isDropdownOpen }"
      />
    </button>

    <!-- Dropdown menu -->
    <div
      v-if="isDropdownOpen"
      class="absolute top-[60px] left-0 z-10 divide-y divide-gray-100 shadow rounded-md w-auto text-black"
    >
      <div class="p-4 bg-white rounded-lg-lg">
        <!-- Bedrooms Section -->
        <div class="mb-4">
          <p class="mb-2 text-gray-700">Bedrooms</p>
          <div class="flex flex-row space-x-3">
            <button
              v-for="(range, index) in bedroomRanges"
              :key="index"
              class="w-full px-2 py-1 mb-2 text-gray-700 border"
              :class="{
                'border-secondary text-primary': isSelected(range, 'bedroom'),
                [`rounded-${radius}`]: true,
                'bg-primary': isBedroomSelected(range),
              }"
              @click="handleMenuItemClick(range, 'bedroom')"
            >
              {{ range.label }}
            </button>
          </div>
        </div>

        <!-- Confirmation Button -->
        <!-- <button
            v-if="isSelectionComplete"
            class="w-full px-2 py-1 mt-4 text-white border rounded-lg bg-primary focus:outline-none"
            @click="closeDropdown"
          >
            Confirm Selection
          </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import DropdownIconSvg from "@/components/svg/DropDownIconSvg.vue";
export default {
  components: {
    DropdownIconSvg,
  },
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    radius: {
      type: String,
    },
    height: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const dropdownContainer = ref(null);
    const isDropdownOpen = ref(false);
    const selectedBedroom = ref(null);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    const handleClickOutside = (event) => {
      if (
        dropdownContainer.value &&
        !dropdownContainer.value.contains(event.target)
      ) {
        closeDropdown();
      }
    };

    const handleMenuItemClick = (item, type) => {
      if (type === "bedroom") {
        selectedBedroom.value = item;
      }
    };

    const isSelected = (item, type) => {
      if (type === "bedroom") {
        return selectedBedroom.value === item;
      }
    };

    const isBedroomSelected = (item) => {
      return selectedBedroom.value === item;
    };

    const isSelectionComplete = computed(() => {
      return selectedBedroom.value;
    });

    const selectionText = computed(() => {
      if (isSelectionComplete.value) {
        emit("BedSelected", {
          Bedroom: selectedBedroom.value,
        });
        return `${selectedBedroom.value.label} Bed`;
      } else {
        return props.buttonLabel;
      }
    });

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    const bedroomRanges = [
      { label: "studio", value: "studio" },
      { label: "1", value: "1" },
      { label: "2", value: "2" },
      { label: "3", value: "3" },
      { label: "4", value: "4" },
      { label: "5", value: "5" },
      { label: "6", value: "6" },
      { label: "7+", value: "7+" },
    ];

    return {
      dropdownContainer,
      isDropdownOpen,
      toggleDropdown,
      closeDropdown,
      handleMenuItemClick,
      isSelected,
      isBedroomSelected,
      isSelectionComplete,
      selectionText,
      bedroomRanges,
    };
  },
};
</script>
